<template>
  <v-main>
    <v-container>
      <v-card max-width="1200" class="mx-auto mt-12 pa-10">
        <v-card-text class="pb-0">
          <p class="helmi-card-title">
            Tarkistuspyynnöt
          </p>
          <table
            style="width: 100%;border-collapse: separate;border-spacing: 12px;"
          >
            <tr
              v-for="verification in verifications"
              :key="verification.id"
            >
              <td>
                {{ verification.email || '-' }}
              </td>
              <td>
                {{ verification.status }}
              </td>
              <td>
                <a :href="`https://rmr.fi/public/app/file-verification/${verification.hash}`">
                  https://rmr.fi/public/app/file-verification/{{ verification.hash }}
                </a>
              </td>
              <td>
                <v-btn
                  v-if="verification.status === 'uploaded'"
                  depressed
                  color="primary"
                  @click="download(verification.file_id)"
                >
                  Lataa
                </v-btn>
              </td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="primary"
            @click="create()"
          >
            Luo uusi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import { apiGet, apiPost } from '../api';

export default {
  name: 'Verifications',

  data: () => ({
    verifications: [],
  }),
  mounted() {
    this.getVerifications();
  },
  methods: {
    async getVerifications() {
      const response = await apiGet('attachments/verification/list');

      if (response.success) {
        this.verifications = response.verifications;
      }
    },
    async create() {
      await apiPost('attachments/verification/create');
      await this.getVerifications();
    },
    async download(id) {
      const response = await apiGet(`attachments/${id}/download`);

      const a = document.createElement('a');
      a.target = '_blank';
      a.href = response.url;
      a.download = `tiedosto_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(response.url);
      a.remove();
    },
  },
};
</script>
<style scoped lang="scss">
* {
  font-family: 'Quicksand', sans-serif;
}
</style>
